/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * Factory which builds a filter that determines if a variable is an array, useful in a template.
 *
 * @ngInject
 */
function IsArrayFilterFactory($log) {
    const filter = function(data) {
        return angular.isArray(data);
    };

    $log.debug('Factory \'IsArrayFilter\' loaded');
    return filter;
}

export { IsArrayFilterFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/filter/IsArrayFilter.js